export default {

  AGPC1: 'rgb(226, 13, 13)',
  BGPC1: 'rgb(226, 119, 13)',
  JEMC1: 'rgb(226, 13, 226)',
  JMWC1: 'rgb(15, 165, 20)',
  MAMC1: 'rgb(13, 119, 226)',
  RCKC1: 'rgb(119, 13, 226)',
  SAWC1: 'rgb(119, 226, 13)',
  SOUC1: 'rgb(156, 88, 0)',
  TIRC1: 'rgb(13, 226, 226)',
  VGAC1: 'rgb(226, 226, 13)',

  Average: 'rgb(232, 232, 232)',
  Median: 'rgb(0, 0, 0)',

};



// WEBPACK FOOTER //
// ./src/models/stationColors.js